import { io, type Socket } from 'socket.io-client';
import { useAuthStore } from '@/stores/authStore';
import { useCallStore } from '@/stores/callStore';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL ?? 'http://localhost:3001';

let socket: Socket | null = null;

export function connectSocket(): Socket {
  const { accessToken, user } = useAuthStore.getState();

  socket = io(SOCKET_URL, {
    auth: { token: accessToken, userId: user?.id },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  });

  socket.on('connect', () => {
    console.log('Connected to WebSocket');
  });

  socket.on('disconnect', () => {
    console.log('Disconnected from WebSocket');
  });

  // Call events
  socket.on('call:incoming', (data: { callId: string; isRepeatCaller: boolean; isNew: boolean; leadId?: string }) => {
    useCallStore.getState().addIncomingCall(data);
  });

  socket.on('call:initiated', (data: { callId: string; agentId: string; agentName: string; leadId?: string }) => {
    useCallStore.getState().setActiveCall({ id: data.callId, agentId: data.agentId, status: 'ringing' });
  });

  socket.on('call:ended', (data: { callId: string; agentId: string }) => {
    useCallStore.getState().endCall(data.callId);
  });

  socket.on('agent:availability_changed', (data: { agentId: string; isAvailable: boolean }) => {
    // Update agent availability in store
    console.log('Agent availability changed:', data);
  });

  return socket;
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}

export function getSocket(): Socket | null {
  return socket;
}
